import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const AcknowledgmentScreen = ({ schema }) => {
  const { body } = schema;

  return (
    <>
      <div className="pwd-disclaimer-body">
        <p className="modal-centered-icon pwd-disclaimer-icon">
          <FaExclamationTriangle color={"#e9e9e9"} size={"2em"} />
        </p>
        <p className="pwd-disclaimer-text">{body}</p>
      </div>
    </>
  );
};

export default AcknowledgmentScreen;
